import mixins from './../_mixins-missmatch-monitor';

export default {
    name: 'TabAccounts',
    mixins: [mixins],
    props: {
        items: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items.map(x => {
                return {
                    uuid: x.account.uuid,
                    status: x.has_mismatch ? 'failed' : 'success',
                    account: x.account.id_object,
                    holders: x.account.holders,
                    show_details: true,
                    comparisons: x.comparisons,
                    class: x.account.class
                };
            });
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return ['account', 'holders', 'show_details'];
        }
    }
};
